<!-- 密码验证 -->
<template>
  <dialogBody :showCance="false" @confirm="confirm" @cancel="cancel" ref="body">
    <template slot="title">
      {{title}}
    </template>
    <div class="infolist-out-table-box custom-scrollbar" style="max-height: 400px;">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th>变量名称</th>
          <th>实时值</th>
          <th>变量类型</th>
          <th>所属设备no</th>
        </tr>
        <tr v-for="(item, i) in dataList">
          <td width="40%">{{item.name}}</td>
          <td width="20%">{{item.rtValue}}</td>
          <td width="20%">{{item.typeName}}</td>
          <td width="20%">{{item.deviceNo}}</td>
        </tr>
      </table>
      <div class="flexCenter" v-show="dataList.length < totalSize">
        <p class="loadMore" @click="getMore">加载更多...</p>
      </div>
    </div>
  </dialogBody>
</template>

<script>
  import dialogBody from '@/components/module/dialog/dialogBody.vue'
  export default {
    components: {
      dialogBody
    },
    props: {

    },
    data () {
      return {
        title: '',
        callback: undefined,
        nowDevice: {},
        dataList: [],
        nowIndex: 1,
        totalSize: 0,
      }
    },
    computed: {

    },
    watch: {},
    mounted () {},
    methods: {
      confirm () {
        this.close()
      },
      cancel () {
        this.close()
      },
      close () {
        this.nowIndex=1
        this.totalSize=0
        this.$refs.body.hide()
      },
      open (title,deviceInfo) {
        this.title=title
        this.nowDevice=deviceInfo
        this.getVariableList()
        this.$refs.body.open()
      },
      getVariableList () {
        this.$api.channelApi.getGenerallyVariableByDeviceNoLimit(this.nowDevice.no,1,100,respon => {
          this.totalSize=respon.total
          this.dataList=respon.data
        })
      },
      getMore () {
        this.nowIndex+=1
        this.$api.channelApi.getGenerallyVariableByDeviceNoLimit(this.nowDevice.no,this.nowIndex,100,respon => {
          this.totalSize=respon.total
          this.dataList.addAll(respon.data)
        })
      },
    }
  }
</script>
<style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
  }

  tr {
    border-bottom: 1px solid #E4E4E4;
  }

  th,
  td {
    line-height: 32px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  >>>.message-content {
    width: 1000px;
    padding: 0;
    overflow: hidden;
  }

  >>>.titles {
    height: 36px;
    line-height: 36px;
    margin: 0;
    padding: 0 10px;
    background: #287AF4;
    color: #FFFFFF;
    font-weight: normal;
  }

  .loadMore {
    background: #287AF4;
    color: #FFFFFF;
    line-height: 32px;
    padding: 0 10px;
    border-radius: 5px;
    margin-top: 10px;
    cursor: pointer;
  }
</style>